import logger from '@d-shared/helpers/logger/logger';

import { getErrorMessage } from '@d-shared/utils/errors';

class ErrorHandler {
  constructor(Vue) {
    this._vue = Vue;
    this._vue.config.errorHandler = this.vueErrorHandler;

    // TODO: re-enable once Google One Tap issues are sorted
    // window.addEventListener('error', this.windowErrorHandler);
    // window.addEventListener('unhandledrejection', this.windowErrorHandler);
  }

  log(error) {
    logger.error(error);
  }

  notify(error, swallow = false) {
    if (this._vue.duiNotificationManager) {
      this._vue.duiNotificationManager.error(getErrorMessage(error));
    }

    if (swallow) {
      return;
    }

    this.log(error);
  }

  vueErrorHandler(error, component, trace) {
    logger.error(error, {
      component: component,
      trace: trace,
    });
  }

  windowErrorHandler(event) {
    event.preventDefault();
    event.stopPropagation();

    if (!!event.reason) {
      logger.error(event.reason);
      return;
    }

    logger.error(event.error);
  }
}

export default {
  install(Vue) {
    Vue.prototype.$errorHandler = new ErrorHandler(Vue);
  },
};
